import React, { PureComponent } from 'react';
import { Button, FormControl, FormControlLabel, RadioGroup, Typography, Link, Radio, Grid } from '@material-ui/core';
import { MILESTONE, MAIN, EXISTING } from '../Constants/Constants';
import SearchBarWithChips from '../../../../common/SearchBarWithChips';
import { FileUploader } from './';
import { SCHEDULED_TEST_SAMPLE_MAIN, SCHEDULED_TEST_SAMPLE_MILESTONE, SCHEDULE_TEST_SAMPLE_FILE_URL } from '../../../../Constants/constants';
import { MyPATMultiSearch } from '../../../../../common';

interface BulkTestAdderProps {
  classes: any;
  setRadioSelection: Function;
  // downloadUrl: string;
  testTypeError: string;
  testType: string;
  renderSelectGoalOptions: Function;
  handleScheduledTestSelection: Function;
  scheduleTestSuggestions: any;
  handleUpload: React.MouseEventHandler<HTMLElement>;
  handleAddSuggestionTests: React.MouseEventHandler<HTMLElement>;
  handleFileInput: Function;
  hasScheduledTestSuggestions: boolean;
  hasSelectedGoal: boolean;
  hasSelectedTests: boolean;
  packages: any[];
  handlePackageSelect: Function;
  selectedPackage: any;
  importedTests: any[]
}
export default class BulkTestAdder extends PureComponent<BulkTestAdderProps> {
  render() {
    const {
      // downloadUrl,
      classes,
      setRadioSelection,
      testTypeError,
      testType,
      renderSelectGoalOptions,
      scheduleTestSuggestions,
      handleUpload,
      handleScheduledTestSelection,
      handleAddSuggestionTests,
      handleFileInput,
      hasScheduledTestSuggestions,
      hasSelectedGoal,
      hasSelectedTests,
      packages,
      handlePackageSelect,
      selectedPackage,
      importedTests
    } = this.props;
    return (
      <div>
        <div className={classes.root}>
          <FormControl component='fieldset'>
            <RadioGroup>
              <FormControlLabel
                value={'Upload Main Test'}
                control={<Radio color='primary' onClick={() => setRadioSelection(MAIN)} />}
                label={'Upload Main Test'}
                checked={testType === MAIN}
              />

              <FormControlLabel
                value={'Upload Milestone Test'}
                control={<Radio color='primary' onClick={() => setRadioSelection(MILESTONE)} />}
                label={'Upload Milestone Test'}
                checked={testType === MILESTONE}
              />

              <FormControlLabel
                value={'Import Existing Tests'}
                control={<Radio color='primary' onClick={() => setRadioSelection(EXISTING)} />}
                label={'Import Existing Tests'}
                checked={testType === EXISTING}
              />
            </RadioGroup>
          </FormControl>
          <div style={{ color: 'red' }}>{testTypeError}</div>
        </div>
        {renderSelectGoalOptions()}
        
        {testType === EXISTING ? (
          <>
            <Grid item xs={12} className={classes.customSelect}>
                    <Typography className={classes.inputLable}>  Select A Course </Typography>
                    <MyPATMultiSearch
                      options={packages}
                      labelKey='name'
                      valueKey='_id'
                      onChange={handlePackageSelect}
                      values={selectedPackage}
                      isSearchAble
                      showAllOptionsOnFocus
                      // isCustomFilter
                      // filtredFunction={this.getSearchResult}
                      name="course"
                      placeholderText='Search Courses'
                      // error={error.creator.showError}
                      // errorText={error.creator.errorText}
                    />

                </Grid>
            <div>
              <Typography className={classes.inputLable} style={{ marginTop: '12px' }}>
                Select Scheduled Tests
                <span className={classes.colorRed}>*</span>
              </Typography>
              <SearchBarWithChips
                classes={{ root: classes.searchBarChips }}
                suggestions={scheduleTestSuggestions}
                placeholderText={hasSelectedGoal ? hasScheduledTestSuggestions ? 'Select Scheduled Tests' : "No test found under this goal" : ''}
                onSelection={(selection: any) => {
                  handleScheduledTestSelection(selection);
                }}
                disabled={!hasSelectedGoal || !hasScheduledTestSuggestions}
                values={importedTests}
              />
            </div>
            <Grid container justify='center'>
              <Button
                variant='contained'
                color='primary'
                style={{ marginTop: '25px' }}
                onClick={handleAddSuggestionTests}
                disabled={!hasSelectedTests}
              >
                Add Tests
              </Button>
            </Grid>
          </>
        ) : (
          
              <>
                <span className={classes.dragDropVideoCustome}>
                  <FileUploader videoUploadHandler={handleFileInput} />
                </span>
                <div style={{ textAlign: 'center' }}>
                  <span className={classes.fileTypeInfo}>Kindly upload data only in the sample format .CSV</span>
                </div>
                <div className={classes.downloadSample}>
                  <Link href= { testType === MAIN ? SCHEDULED_TEST_SAMPLE_MAIN : SCHEDULED_TEST_SAMPLE_MILESTONE } target='_blank' download>
                    <img src='/assets/svg/learn/downloadIcon.svg' alt='download-icon' /> Download Sample Format
                  </Link>
                </div>
                <Grid container justify='center'>
                  <Button variant='contained' color='primary' onClick={handleUpload}
                  disabled = {testType ? false : true }
                  >
                    Upload File
                  </Button>
                </Grid>
              </>
        )}
      </div>
    );
  }
}
